import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IMainVisualBannerProps {
  $sizeType?: 'default' | 'small';
}

export const MainVisualBanner = styled.div<IMainVisualBannerProps>`
  position: relative;
  overflow: hidden;

  &.has-text .visual-wrap:after {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.04);
    pointer-events: none;
  }

  .visual-wrap {
    position: relative;
    height: ${({ $sizeType }) =>
      $sizeType === 'default' ? mixin.pxToVw('525') : mixin.pxToVw('400')};
  }

  .video-wrap {
    .veVideo {
      position: absolute;
      height: 100%;
      background: none;

      > div {
        height: 100%;
      }

      &.is-player-play {
        position: relative;

        + .video-poster {
          display: none;
        }
      }

      video {
        width: 100.2%;
        height: 100.2%;
        transform: translate(-0.1%, -0.1%);
      }

      .area-poster {
        width: 100.2%;
        height: 100.2%;
        top: -0.1%;
        left: -0.1%;
      }
    }

    .video-poster {
      width: 100.2%;
      height: 100.2%;
      position: absolute;
      top: -0.1%;
      left: -0.1%;
    }
  }

  .img-wrap .img {
    height: 100%;
  }

  .text-wrap {
    width: 100%;
    height: 150px;
    ${mixin.flex({
      direction: 'column',
      align: 'flex-start',
      justify: 'flex-end',
    })};
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 0 30px 60px;
    z-index: 1;

    .title + .sub-title {
      margin-top: 4px;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    .text-wrap {
      height: ${mixin.pxToVw('150')};
      padding: ${mixin.pxToVw('0 30 60')};

      .title + .sub-title {
        margin-top: ${mixin.pxToVw('4')};
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    &.has-text .visual-wrap:after {
      background: rgba(0, 0, 0, 0.1);
    }

    .visual-wrap {
      height: ${({ $sizeType }) => ($sizeType === 'default' ? 1000 : 773)}px;
    }

    .text-wrap {
      height: 100%;
      padding: 70px 91px;

      .title {
        font-size: 80px;
        line-height: 88px;

        + .sub-title {
          margin-top: 42px;
        }
      }

      .sub-title {
        font-size: 20px;
        line-height: 30px;
      }
    }
  }
`;
